<script>
          import MY_JSON from './letters.json'
          export default{
              //custom option named myJson
                 myJson: MY_JSON
          }
</script>